import React from "react";
import SocialShare from "@qlik/qlik/src/components/Common/SocialShare";
import RichText from "@qlik/qlik/src/components/RichText";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { RESOURCE_PATHNAME } from "@qlik/qlik/src/lib/constants/resource-constants";
import * as styles from "@qlik/qlik/src/components/RichText/styles.module.css";
import * as resourceStyles from "./styles.module.css";

const ResourceSingleEntry = ({ data }) => {
    const { slug, title, body } = data ?? {};

    return (
        <section className="resource-single-entry pb-10 pt-15 lg:pt-20 relative">
            <div className="container">
                <div className="xl:pb-14 lg:mx-25">
                    <SocialShare
                        pageTitle={title}
                        pageSlug={`${RESOURCE_PATHNAME}/${slug}`}
                        startElementSelector=".resource-single-entry"
                        stopElementSelector=".resource-single-entry"
                        startElementPosition="top"
                        stopElementPosition="bottom"
                        additionalClasses="lg:mb-17.5"
                    />
                    {title && (
                        <h1
                            className="title-2 text-with-color mb-5 xl:mb-15"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                    )}
                    {body?.raw && (
                        <div className={`${styles.richtextWrapper} ${resourceStyles.resourceRichtextWrapper}`}>
                            <RichText data={data} />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ResourceSingleEntry;
